import { Box } from '@fhs-legacy/universal-components';

export default Box;
